import React from 'react';
import InternalError from 'icons/img/InternalError.png';
import { IcoBlueBell } from 'icons/indexed-icons/IcoBlueBell';
import BlueGears from 'icons/img/BlueGears.png';
import CrossedOverCone from 'icons/img/CrossedOverCone.png';
import NoDataOpenBox from 'icons/img/no_data_open_box.png';
import comingsoon from 'icons/img/coming_soon.png';

export const DataLoaderIcons: Record<string, JSX.Element> = {
  'no alerts': <IcoBlueBell />,
  'no data': <img src={BlueGears} alt="no data" className="icon icon--no-data" />,
  hasError: <img src={InternalError} alt="internal error" className="icon icon--internal-error" />,
  'no downtime events': <img src={CrossedOverCone} alt="no data" className="icon icon--no-events" />,
  'no_data_empty_box': <img src={NoDataOpenBox} alt="no data" className="icon icon--no-data-box" />,
  'comingSoon': <img src={comingsoon} alt="coming soon" className="icon icon--coming-soon" />
};
